import { answerParentFrame, isInFrame } from './auth/silentFrame';

// A frame never boots the app (Bug 41840). The redirect address is the whole app, so each silent renewal used to boot a
// second, signed-in portal inside its hidden frame, with its own Clarity session, its own live connection and its own
// renewal frame, and MSAL never got its answer.
if (isInFrame()) void answerParentFrame();
else void import('./boot');
